import React from 'react';
import { ATMGrid, ATMHeader, ATMSegment } from 'shared-it-appmod-ui';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';
import Moment from 'src/libraries/moment.library';
import { IRequest } from 'src/models/request.model';

type IProps = {
  data: IRequest;
};

const FlightRequestDate: React.FC<IProps> = ({ data: { request } }) => {
  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_DATE_TIME}</ATMHeader>
      <ATMGrid columns={3}>
        <ATMGrid.Row>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_REQUEST_FLIGHT_START_DATE} inline>
              {Moment(request.flightDate).format('MM/DD/YYYY')}
            </FieldReadOnly>
          </ATMGrid.Column>
          {request?.flightEndDate && (
            <ATMGrid.Column>
              <FieldReadOnly label={Lang.LBL_REQUEST_FLIGHT_END_DATE} inline>
                {Moment.utc(request?.flightEndDate).tz('America/Los_Angeles').format('MM/DD/YYYY')}
              </FieldReadOnly>
            </ATMGrid.Column>
          )}
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_REQUEST_RECEIVED_DATE} inline>
              {Moment(request.requestDate).format('MM/DD/YYYY')}
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_REQUEST_FLIGHT_START_TIME} inline>
              {request.startTime?.replace(':', '')} hours
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_REQUEST_FLIGHT_DURATION} inline>
              {request.flightDuration} hrs
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly
              label={Lang.LBL_REQUEST_FLIGHT_RELEASE_STANDBY_TIME}
              inline
            >
              {request.releaseTime}
            </FieldReadOnly>
          </ATMGrid.Column>
        </ATMGrid.Row>
      </ATMGrid>
    </ATMSegment>
  );
};

export default FlightRequestDate;
